// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { tap, take } from "rxjs/operators";
import { Employee } from "../model/employee";

const CREATE_ACTION = "Create";
const UPDATE_ACTION = "Update";
const REMOVE_ACTION = "Destroy";

function noop() {
  /* */
}

@Injectable()
export class EmployeeEditService extends BehaviorSubject<Employee[]> {
  constructor(private http: HttpClient) {
    super(null);
  }

  public read(): void {
    this.fetch("")
      .pipe(take(1))
      .subscribe((data) => this.next(data));
  }

  public fetchChildren(reportsTo: number = null): Observable<Employee[]> {
    return this.http.get<Employee[]>(
      `https://demos.telerik.com/service/v2/core/EmployeeDirectory/?id=${reportsTo}`,
    );
  }

  public update(item: Employee): void {
    this.save(item, null, false).pipe(take(1)).subscribe(noop);
  }

  public save(
    item: Employee,
    parent: Employee,
    isNew: boolean,
  ): Observable<Employee[]> {
    const action = isNew ? CREATE_ACTION : UPDATE_ACTION;

    return this.fetch(action, item).pipe(
      tap(() => {
        if (!parent && isNew) {
          this.read();
        }
      }),
    );
  }

  public remove(item: any, parent?: Employee): Observable<Employee[]> {
    return this.fetch(REMOVE_ACTION, item).pipe(
      tap(() => {
        if (!parent) {
          this.read();
        }
      }),
    );
  }

  private serializeModels(data?: Employee[]): string {
    return data ? `${JSON.stringify([data])}` : "";
  }

  private fetch(action = "", data?: any, id?: any): Observable<Employee[]> {
    return this.http.post<Employee[]>(
      `https://demos.telerik.com/service/v2/core/EmployeeDirectory/${action}`,
      this.serializeModels(data),
      {
        headers: { "Content-Type": "application/json" },
      },
    );
  }
}
